import Service from './FormWidgetSubmitService'

export default {
    data(){
        return {
            errors: false,
            model: {},
            saved: false,
            showMessage: false,
            submitted: false,
            widgetId: 0,
        }
    },
    methods: {
        checkStatus(response){
            if (response.status == 'error') {
                this.errors = response.messages.errors

                return false
            }

            return true
        },
        getParameterByName(name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, "\\$&");
            let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url)
            if (!results) return null
            if (!results[2]) return ''

            return decodeURIComponent(results[2].replace(/\+/g, " "))
        },
        getService(){
            let language = _.isNull(document.querySelector('meta#language')) ? false : document.querySelector('meta#language').getAttribute('value');
            return new Service(this.widgetId, language)
        },
        hasError(label){
            if (_.isUndefined(this.errors))
                return false

            if (this.errors === false)
                return false

            if (_.isUndefined(this.errors[label]))
                return false

            return true
        },
        init(widgetId, model){
            this.model = model
            this.widgetId = widgetId
        },
        isReady(){
            return !_.isUndefined(this.model) && widgetId > 0
        },
        onSubmitForm(e) {
            e.preventDefault()
            this.saved = false
            this.errors = false
            this.showMessage = false

            this.store(this.model)

        },
        postStore(response){
        },
        preStore(response){
        },
        store(model){
            let service = this.getService()
            service.store(model, (response) => {

                if (!this.checkStatus(response))
                    return

                this.preStore(response)
                this.model = response.data.results
                this.saved = true
                this.showMessage = true
                this.postStore(response)
            })
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/ui/src/core/site/forms/core/FormWidgetMixin.js